import { Add, Remove } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { COLORS } from "assets";
import StyledInputLabel from "./StyledInputLabel";
import StyledHelperText from "./StyledHelperText";

export interface NumberStepperProps {
  label: string;
  value: number;
  min?: number;
  max?: number;
  error?: string;
  onChange: (value: number) => void;
}

export default function NumberStepper({ label, value, min = 1, max = 10, error, onChange }: NumberStepperProps) {
  const decrement = () => onChange(Math.max(min, value - 1));
  const increment = () => onChange(Math.min(max, value + 1));

  return (
    <Box>
      <StyledInputLabel>{label}</StyledInputLabel>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: 48,
          borderRadius: `${COLORS.radius.pill}px`,
          border: `1px solid ${error ? COLORS.error : COLORS.surface.border}`,
          bgcolor: COLORS.surface.card,
          overflow: "hidden"
        }}
      >
        <IconButton
          onClick={decrement}
          disabled={value <= min}
          aria-label={`Decrease ${label}`}
          sx={{
            width: 48,
            height: 48,
            borderRadius: 0,
            color: COLORS.surface.secondaryText,
            "&:hover": { bgcolor: COLORS.surface.tableHeader }
          }}
        >
          <Remove fontSize="small" />
        </IconButton>
        <Typography
          component="span"
          sx={{
            flex: 1,
            textAlign: "center",
            fontWeight: 600,
            fontSize: 16,
            color: COLORS.surface.primaryText,
            userSelect: "none"
          }}
        >
          {value}
        </Typography>
        <IconButton
          onClick={increment}
          disabled={value >= max}
          aria-label={`Increase ${label}`}
          sx={{
            width: 48,
            height: 48,
            borderRadius: 0,
            color: COLORS.surface.secondaryText,
            "&:hover": { bgcolor: COLORS.surface.tableHeader }
          }}
        >
          <Add fontSize="small" />
        </IconButton>
      </Box>
      {error ? <StyledHelperText error>{error}</StyledHelperText> : null}
    </Box>
  );
}
